/* Matres — Build Your Bundle engine.
 * Reads window.MATRES_BUNDLE (data: tiers, ladder, cats) and
 * window.MATRES_BUNDLE_STRINGS (localized UI labels — no hardcoded copy here).
 * Bills the hidden price-ladder variant at the discounted total; the picked real
 * items ride as line-item properties (a Shopify Flow decrements their stock from _items).
 */
(function () {
  var root = document.querySelector('[data-bundle-builder]');
  if (!root) return;
  var D = window.MATRES_BUNDLE || {};
  var S = window.MATRES_BUNDLE_STRINGS || {};
  var M = window.MATRES || {};
  var LOCALE = M.locale === 'ar' ? 'ar' : 'en';
  if (!D.cats || !D.ladder || !D.ladder.length) {
    root.innerHTML = '<p style="padding:20px;text-align:center;color:rgb(120,106,91)">' + (S.unavailable || 'Bundle builder is unavailable right now.') + '</p>';
    return;
  }
  function money(c) { return window.MatresMoney ? window.MatresMoney(c) : ((M.currency && M.currency.iso) || 'QAR') + ' ' + (Math.round(c) / 100).toFixed(2); }
  function t(k, fb) { return S[k] || fb || k; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function catBy(k) { return D.cats.filter(function (c) { return c.key === k; })[0]; }

  var sizedCats = D.cats.filter(function (c) { return c.type === 'sized'; });
  var sizeList = sizedCats[0] ? Object.keys(sizedCats[0].sizes) : [];
  sizeList.sort(function (a, b) { return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0); });

  var state = { size: sizeList[0] || null, picked: {}, pillowQty: {} };

  /* ── pricing ─────────────────────────────────────────────── */
  function tierPct(sumMajor) { var p = 0; (D.tiers || []).forEach(function (x) { if (sumMajor >= x.min) p = x.pct; }); return p; }
  function nextTier(sumMajor) { var n = null; (D.tiers || []).forEach(function (x) { if (sumMajor < x.min && (!n || x.min < n.min)) n = x; }); return n; }
  function ladderStep(amountMajor) {
    var best = null, diff = Infinity;
    (D.ladder || []).forEach(function (s) { var d = Math.abs(s.a - amountMajor); if (d < diff) { diff = d; best = s; } });
    return best;
  }
  function collect() {
    var lines = [], sum = 0;
    sizedCats.forEach(function (c) {
      if (state.picked[c.key]) { var v = c.sizes[state.size]; if (v && v.avail) { lines.push({ cat: c.key, name: c.name, bi: c.biName, meta: state.size, price: +v.price, id: v.id, qty: 1 }); sum += +v.price; } }
    });
    var sh = catBy('sheets');
    if (sh && state.picked.sheets) { var col = sh.colors.filter(function (x) { return x.en === state.picked.sheets; })[0]; if (col && col.avail) { lines.push({ cat: 'sheets', name: t('sheetsLabel', 'Bed sheets'), bi: col.biName, meta: (LOCALE === 'ar' ? col.ar : col.en), metaAr: col.ar, metaEn: col.en, price: +col.price, id: col.id, qty: 1 }); sum += +col.price; } }
    D.cats.filter(function (mc) { return mc.type === 'multi'; }).forEach(function (mc) {
      mc.items.forEach(function (it, i) { var q = state.pillowQty[mc.key + ':' + i] || 0; if (q > 0) { lines.push({ cat: mc.key, name: it.name, bi: it.biName, meta: '×' + q, price: (+it.price) * q, id: it.id, qty: q }); sum += (+it.price) * q; } });
    });
    return { lines: lines, sum: sum };
  }
  function pricing() {
    var c = collect(), sumMajor = c.sum / 100, pct = tierPct(sumMajor);
    var discounted = c.sum * (1 - pct / 100);
    var step = ladderStep(Math.round(discounted / 100));
    var total = step ? step.a * 100 : Math.round(discounted);
    return { lines: c.lines, sum: c.sum, pct: pct, total: total, save: Math.max(0, c.sum - total), billId: step ? step.id : null, sumMajor: sumMajor };
  }

  /* ── render ──────────────────────────────────────────────── */
  var GOLD = '#C9A15C', ESPRESSO = 'rgb(83,66,48)', NAVY = 'rgb(29,36,56)';
  function card(inner, on) { return '<div style="border:1.5px solid ' + (on ? GOLD : '#E9E0D2') + ';border-radius:14px;background:' + (on ? '#FBF8F3' : '#fff') + ';padding:14px;transition:border-color .15s,background .15s;">' + inner + '</div>'; }

  /* Clickable thumbnail with a magnifier badge → opens the quick-view preview. */
  function thumb(image, spec, size) {
    size = size || 52;
    if (!image) return '';
    return '<button type="button" class="bb-thumb" data-bb-preview="' + esc(spec) + '" title="' + esc(t('quickView', 'Quick view')) + '" style="width:' + size + 'px;height:' + size + 'px;">' +
      '<img src="' + esc(image) + '" alt="" width="' + size + '" height="' + size + '">' +
      '<span class="bb-thumb-eye" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2" stroke-linecap="round"/></svg></span>' +
    '</button>';
  }

  /* ── quick-view preview modal ────────────────────────────── */
  function previewData(spec) {
    var parts = String(spec).split(':'), kind = parts[0], id = parts[1];
    if (kind === 'sized') {
      var c = catBy(id); if (!c) return null;
      var v = c.sizes[state.size];
      return { name: c.name, image: c.image, desc: c.desc, url: c.url, price: (v && v.avail) ? +v.price : null, meta: (v && v.avail) ? state.size : null };
    }
    if (kind === 'sheet') {
      var sh = catBy('sheets'); if (!sh) return null;
      var col = sh.colors.filter(function (x) { return x.en === state.picked.sheets; })[0] || sh.colors[0];
      if (!col) return null;
      return { name: t('sheetsLabel', 'Bed sheets') + ' — ' + (LOCALE === 'ar' ? col.ar : col.en), image: col.image || sh.image, desc: col.desc, url: col.url, price: +col.price };
    }
    if (kind === 'pillow') {
      var mc = catBy(id); if (!mc) return null;
      var it = mc.items[+parts[2]]; if (!it) return null;
      return { name: it.name, image: it.image, desc: it.desc, url: it.url, price: +it.price };
    }
    return null;
  }

  var modalEl = null;
  function closePreview() { if (modalEl) { modalEl.remove(); modalEl = null; document.removeEventListener('keydown', onModalKey); } }
  function onModalKey(e) { if (e.key === 'Escape') closePreview(); }
  function openPreview(data) {
    if (!data) return;
    closePreview();
    var el = document.createElement('div');
    el.className = 'bb-modal';
    el.dir = LOCALE === 'ar' ? 'rtl' : 'ltr';
    el.innerHTML =
      '<div class="bb-modal-card" role="dialog" aria-modal="true" aria-label="' + esc(data.name) + '">' +
        '<button type="button" class="bb-modal-close" data-bb-close aria-label="' + esc(t('close', 'Close')) + '">&times;</button>' +
        (data.image ? '<img class="bb-modal-img" src="' + esc(data.image) + '" alt="' + esc(data.name) + '">' : '') +
        '<div class="bb-modal-body">' +
          '<h4 class="bb-modal-title">' + esc(data.name) + '</h4>' +
          (data.price != null ? '<div class="bb-modal-price">' + esc(money(data.price)) + (data.meta ? ' <span>· ' + esc(data.meta) + '</span>' : '') + '</div>' : '') +
          (data.desc ? '<p class="bb-modal-desc">' + esc(data.desc) + '</p>' : '') +
          (data.url ? '<a class="bb-modal-link" href="' + esc(data.url) + '" target="_blank" rel="noopener">' + esc(t('viewDetails', 'View full details')) + ' →</a>' : '') +
        '</div>' +
      '</div>';
    el.addEventListener('click', function (e) { if (e.target === el || (e.target.closest && e.target.closest('[data-bb-close]'))) closePreview(); });
    document.body.appendChild(el);
    modalEl = el;
    document.addEventListener('keydown', onModalKey);
  }

  function renderSizes() {
    if (!sizeList.length) return '';
    var btns = sizeList.map(function (s) {
      var on = state.size === s;
      return '<button type="button" data-bb-size="' + esc(s) + '" aria-pressed="' + on + '" style="flex:1;min-width:78px;padding:12px 8px;border-radius:10px;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer;border:1.5px solid ' + (on ? GOLD : '#E9E0D2') + ';background:' + (on ? ESPRESSO : '#fff') + ';color:' + (on ? '#fff' : ESPRESSO) + ';">' + esc(s) + '</button>';
    }).join('');
    return '<div style="margin-bottom:22px;"><h3 style="font-size:16px;font-weight:700;color:' + NAVY + ';margin:0 0 10px;">1 · ' + esc(t('sizeLabel', "What's your bed size?")) + '</h3><div style="display:flex;flex-wrap:wrap;gap:8px;">' + btns + '</div></div>';
  }

  function sizedCard(c) {
    var v = c.sizes[state.size], on = !!state.picked[c.key];
    var avail = v && v.avail;
    var price = avail ? money(+v.price) : t('unavailableSize', 'Not in this size');
    var inner =
      '<div style="display:flex;align-items:center;gap:12px;">' +
        thumb(c.image, 'sized:' + c.key, 52) +
        '<div style="flex:1;min-width:0;"><div style="font-size:14.5px;font-weight:700;color:' + ESPRESSO + ';">' + esc(c.name) + '</div>' +
        '<div style="font-size:13px;color:' + (avail ? 'rgb(140,126,111)' : '#C0392B') + ';">' + esc(price) + '</div></div>' +
        '<button type="button" data-bb-toggle="' + esc(c.key) + '" ' + (avail ? '' : 'disabled') + ' style="flex:none;padding:9px 16px;border-radius:9999px;font-family:inherit;font-size:13px;font-weight:700;cursor:' + (avail ? 'pointer' : 'not-allowed') + ';border:1.5px solid ' + (on ? GOLD : '#E9E0D2') + ';background:' + (on ? GOLD : '#fff') + ';color:' + (on ? '#fff' : ESPRESSO) + ';opacity:' + (avail ? 1 : .5) + ';">' + esc(on ? t('added', 'Added ✓') : t('add', 'Add')) + '</button>' +
      '</div>';
    return card(inner, on);
  }

  function sheetsCard(c) {
    var pills = c.colors.map(function (col) {
      var on = state.picked.sheets === col.en;
      return '<button type="button" data-bb-sheet="' + esc(col.en) + '" ' + (col.avail ? '' : 'disabled') + ' style="display:inline-flex;align-items:center;gap:7px;padding:8px 13px;border-radius:9999px;font-family:inherit;font-size:13px;font-weight:600;cursor:pointer;border:1.5px solid ' + (on ? GOLD : '#E9E0D2') + ';background:' + (on ? '#FBF8F3' : '#fff') + ';color:' + ESPRESSO + ';opacity:' + (col.avail ? 1 : .5) + ';"><span style="width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,.15);background:' + esc(col.hex) + ';"></span>' + esc(LOCALE === 'ar' ? col.ar : col.en) + ' — ' + esc(money(+col.price)) + '</button>';
    }).join('');
    var on = !!state.picked.sheets;
    var inner = '<div style="display:flex;align-items:center;gap:12px;margin-bottom:10px;">' +
      thumb(c.image, 'sheet', 52) +
      '<div style="flex:1;"><div style="font-size:14.5px;font-weight:700;color:' + ESPRESSO + ';">' + esc(t('sheetsLabel', 'Bed sheets (7-piece)')) + '</div><div style="font-size:12.5px;color:rgb(140,126,111);">' + esc(t('colorLabel', 'Pick a colour')) + '</div></div>' +
      (on ? '<button type="button" data-bb-sheet="" style="flex:none;font-size:12px;color:rgb(140,126,111);background:none;border:none;cursor:pointer;text-decoration:underline;">' + esc(t('remove', 'Remove')) + '</button>' : '') +
      '</div><div style="display:flex;flex-wrap:wrap;gap:8px;">' + pills + '</div>';
    return card(inner, on);
  }

  function pillowsCard(c) {
    var rows = c.items.map(function (it, i) {
      var pk = c.key + ':' + i;
      var q = state.pillowQty[pk] || 0;
      return '<div style="display:flex;align-items:center;gap:12px;padding:8px 0;' + (i ? 'border-top:1px solid #F0E9DD;' : '') + '">' +
        thumb(it.image, 'pillow:' + pk, 44) +
        '<div style="flex:1;min-width:0;"><div style="font-size:13.5px;font-weight:600;color:' + ESPRESSO + ';line-height:1.3;">' + esc(it.name) + '</div><div style="font-size:12.5px;color:rgb(140,126,111);">' + esc(money(+it.price)) + '</div></div>' +
        '<div style="display:inline-flex;align-items:center;border:1px solid #E9E0D2;border-radius:9999px;overflow:hidden;flex:none;">' +
          '<button type="button" data-bb-pill="' + pk + '" data-d="-1" aria-label="-" style="width:32px;height:32px;border:none;background:#F5EFE6;cursor:pointer;font-size:16px;color:' + ESPRESSO + ';">−</button>' +
          '<span style="min-width:26px;text-align:center;font-size:14px;font-weight:700;color:' + NAVY + ';">' + q + '</span>' +
          '<button type="button" data-bb-pill="' + pk + '" data-d="1" aria-label="+" style="width:32px;height:32px;border:none;background:#F5EFE6;cursor:pointer;font-size:16px;color:' + ESPRESSO + ';">+</button>' +
        '</div></div>';
    }).join('');
    var any = c.items.some(function (_, i) { return (state.pillowQty[c.key + ':' + i] || 0) > 0; });
    var label = c.key === 'perfumes' ? t('perfumesLabel', 'Home fragrances') : t('pillowsLabel', 'Pillows');
    return card('<div style="font-size:14.5px;font-weight:700;color:' + ESPRESSO + ';margin-bottom:4px;">' + esc(label) + '</div>' + rows, any);
  }

  function renderItems() {
    var cards = [];
    D.cats.forEach(function (c) {
      if (c.type === 'sized') cards.push(sizedCard(c));
      else if (c.type === 'color') cards.push(sheetsCard(c));
      else if (c.type === 'multi') cards.push(pillowsCard(c));
    });
    return '<div style="margin-bottom:22px;"><h3 style="font-size:16px;font-weight:700;color:' + NAVY + ';margin:0 0 10px;">2 · ' + esc(t('itemsLabel', 'Choose your items')) + '</h3><div style="display:flex;flex-direction:column;gap:10px;">' + cards.join('') + '</div></div>';
  }

  function renderSummary() {
    var p = pricing();
    var lines = p.lines.map(function (l) {
      return '<div style="display:flex;justify-content:space-between;gap:10px;font-size:13.5px;color:' + ESPRESSO + ';padding:3px 0;"><span style="min-width:0;">' + esc(l.name) + ' <span style="color:rgb(150,138,125);font-size:12px;">' + esc(l.meta || '') + '</span></span><span style="white-space:nowrap;font-weight:600;">' + esc(money(l.price)) + '</span></div>';
    }).join('');
    var nt = nextTier(p.sumMajor);
    var nudge = '';
    if (p.lines.length && nt) {
      var need = money((nt.min * 100) - p.sum);
      nudge = '<div style="background:#FBF3E4;border:1px solid #EBD9B6;border-radius:10px;padding:9px 12px;font-size:12.5px;color:#8A6D2F;font-weight:600;margin-top:10px;">' + esc(t('nudge', 'Add {x} more → {p}% off').replace('{x}', need).replace('{p}', nt.pct)) + '</div>';
    }
    var body;
    if (!p.lines.length) {
      body = '<p style="font-size:13.5px;color:rgb(140,126,111);text-align:center;padding:14px 0;">' + esc(t('empty', 'Pick your items to start your bundle.')) + '</p>';
    } else {
      body = lines +
        '<div style="border-top:1px dashed #E4D9C6;margin-top:8px;padding-top:8px;">' +
          '<div style="display:flex;justify-content:space-between;font-size:13px;color:rgb(120,106,91);padding:2px 0;"><span>' + esc(t('subtotal', 'Subtotal')) + '</span><span>' + esc(money(p.sum)) + '</span></div>' +
          (p.pct > 0 ? '<div style="display:flex;justify-content:space-between;font-size:13px;color:#2E8B57;font-weight:700;padding:2px 0;"><span>' + esc(t('discount', 'Bundle discount') + ' (' + p.pct + '%)') + '</span><span>− ' + esc(money(p.save)) + '</span></div>' : '') +
          '<div style="display:flex;justify-content:space-between;align-items:baseline;font-size:17px;font-weight:800;color:' + NAVY + ';padding-top:5px;"><span>' + esc(t('total', 'Total')) + '</span><span>' + esc(money(p.total)) + '</span></div>' +
        '</div>' + nudge;
    }
    var canAdd = p.lines.length && p.billId;
    return '<div style="border:1.5px solid #E9E0D2;border-radius:16px;background:#fff;padding:16px;box-shadow:0 6px 22px -14px rgba(83,66,48,.25);">' +
      '<h3 style="font-size:16px;font-weight:800;color:' + NAVY + ';margin:0 0 10px;">' + esc(t('summaryTitle', 'Your bundle')) + '</h3>' + body +
      '<button type="button" data-bb-add ' + (canAdd ? '' : 'disabled') + ' style="width:100%;margin-top:14px;background:' + (canAdd ? ESPRESSO : '#c9c1b6') + ';color:#fff;border:none;border-radius:9999px;padding:14px;font-family:inherit;font-size:15px;font-weight:800;cursor:' + (canAdd ? 'pointer' : 'not-allowed') + ';">' + esc(t('addBundle', 'Add bundle to cart')) + '</button>' +
      '<p style="text-align:center;font-size:11.5px;color:rgb(150,138,125);margin:8px 0 0;">' + esc(t('autoNote', 'The discount is applied automatically.')) + '</p>' +
    '</div>';
  }

  function render() {
    root.innerHTML =
      '<div class="matres-bb-grid">' +
        '<div>' + renderSizes() + renderItems() + '</div>' +
        '<div data-bb-summary class="matres-bb-summary">' + renderSummary() + '</div>' +
      '</div>';
  }

  /* ── events ──────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    var pv = e.target.closest('[data-bb-preview]');
    if (pv) { openPreview(previewData(pv.getAttribute('data-bb-preview'))); return; }
    var sz = e.target.closest('[data-bb-size]');
    if (sz) { state.size = sz.getAttribute('data-bb-size'); render(); return; }
    var tg = e.target.closest('[data-bb-toggle]');
    if (tg && !tg.disabled) { var k = tg.getAttribute('data-bb-toggle'); state.picked[k] = !state.picked[k]; render(); return; }
    var sh = e.target.closest('[data-bb-sheet]');
    if (sh && !sh.disabled) { var v = sh.getAttribute('data-bb-sheet'); state.picked.sheets = v || null; render(); return; }
    var pl = e.target.closest('[data-bb-pill]');
    if (pl) {
      var pk = pl.getAttribute('data-bb-pill'), d = parseInt(pl.getAttribute('data-d'), 10);
      var kp = pk.split(':'), mcat = catBy(kp[0]), mit = mcat && mcat.items[+kp[1]];
      var maxq = (mit && mit.maxQty) || 4;
      var cur = state.pillowQty[pk] || 0;
      state.pillowQty[pk] = Math.max(0, Math.min(maxq, cur + d));
      render(); return;
    }
    var add = e.target.closest('[data-bb-add]');
    if (add && !add.disabled) { addBundle(add); return; }
  });

  /* ── add to cart ─────────────────────────────────────────── */
  function addBundle(btn) {
    var p = pricing();
    if (!p.lines.length || !p.billId) return;
    btn.disabled = true; btn.textContent = t('adding', 'Adding…');
    var props = {};
    props[t('propBundle', 'Bundle')] = t('propBundleVal', 'Build Your Bundle');
    /* biName is the bilingual_name metafield: Arabic on line 1, English on line 2. Put the size/qty
       on BOTH lines rather than only after the English half, so the cart, the order and the WhatsApp
       message can each show one clean language without losing which size was picked. */
    p.lines.forEach(function (l, i) {
      var half = String(l.bi || l.name).split('\n');
      var ar = (half[0] || l.name).trim();
      var en = (half[1] || half[0] || l.name).trim();
      /* The sheet colour is the one meta that has a language. Keep each half in its own. */
      var mAr = l.metaAr || l.meta, mEn = l.metaEn || l.meta;
      props[(LOCALE === 'ar' ? 'العنصر ' : 'Item ') + (i + 1)] =
        ar + (mAr ? ' — ' + mAr : '') + '\n' + en + (mEn ? ' — ' + mEn : '');
    });
    props._items = p.lines.map(function (l) { return String(l.id).replace(/\D/g, '') + ':' + l.qty; }).join(',');
    props._bundle = '1';
    props._uid = 'bb' + Date.now() + Math.floor((window.performance ? performance.now() : 0) % 1000);
    var addUrl = (M.routes && M.routes.cartAdd) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(p.billId).replace(/\D/g, ''), quantity: 1, properties: props })
    }).then(function (r) { return r.json(); }).then(function () {
      window.location.href = (M.routes && M.routes.cart) || '/cart';
    }).catch(function () { btn.disabled = false; btn.textContent = t('addBundle', 'Add bundle to cart'); });
  }

  render();
})();
